import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@15.5.9_@opentelemetry+api@1.9.0_react-dom@19.1.1_react@19.1.1__react@19.1.1_sass@1.77.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@15.5.9_@opentelemetry+api@1.9.0_react-dom@19.1.1_react@19.1.1__react@19.1.1_sass@1.77.4/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@15.5.9_@opentelemetry+api@1.9.0_react-dom@19.1.1_react@19.1.1__react@19.1.1_sass@1.77.4/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@15.5.9_@opentelemetry+api@1.9.0_react-dom@19.1.1_react@19.1.1__react@19.1.1_sass@1.77.4/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/workspace/src/app/(frontend)/[...slug]/page.client.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/app/(frontend)/components/jsonld.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/blocks/AboutBlock/Component.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/blocks/AboutBlock2/Component.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/blocks/AboutBlock3/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArchiveBlockClient"] */ "/workspace/src/blocks/ArchiveBlock/ClientComponent.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/blocks/CommentBlock/Component.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/blocks/CTABlocks/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FadeIn","SlideUp"] */ "/workspace/src/blocks/Feature245/ClientAnimations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContainerScroll"] */ "/workspace/src/blocks/Feature249/ClientContainerScroll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PinContainer"] */ "/workspace/src/blocks/Feature270/ClientPinContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Feature6Tabs"] */ "/workspace/src/blocks/Feature6/ClientTabs.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/blocks/FeatureBlocks/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/blocks/FeatureSection/ClientWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/blocks/Form/Component.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/blocks/Form/Component2.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/blocks/FormBlock4/Component.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/blocks/GalleryBlock/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/blocks/hero-parallax/ClientWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/blocks/hero-parallax/Component.module.scss");
;
import(/* webpackMode: "eager" */ "/workspace/src/blocks/Heroblock2/HeroBlock2.css");
;
import(/* webpackMode: "eager" */ "/workspace/src/blocks/Heroblock4/FormIsland.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/blocks/leadgenform/Component.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/blocks/PratnerBlocks/Component.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/blocks/ServicesBlock/Component.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/blocks/TableOfContents/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/blocks/Team1Block/ClientWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/blocks/Team1Block/Component.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialCard"] */ "/workspace/src/blocks/TestoMonialBlock/testomonial-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/blocks/TestoMonialBlock/testomonialBlock2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/blocks/TestoMonialBlock/TestomonialBlock3.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/blocks/videoblock/Component.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/blocks/videoblock2/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuroraText"] */ "/workspace/src/components/aurora-text.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackgroundBeams"] */ "/workspace/src/components/background-beams.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/components/LivePreviewListener/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageMedia"] */ "/workspace/src/components/Media/ImageMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoMedia"] */ "/workspace/src/components/Media/VideoMedia/index.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/components/ui/carousel.tsx");
